export enum TradePointOwnerTypeEnum {
    OnControl,
    Own,
    Franchise,
    Uk,
}
